import { render } from "./scopingtool-page.vue?vue&type=template&id=06bafaf8"
import script from "./scopingtool-page.vue?vue&type=script&lang=js"
export * from "./scopingtool-page.vue?vue&type=script&lang=js"

import "./scopingtool-page.vue?vue&type=style&index=0&id=06bafaf8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__